<template>
  <b-container>
    <b-form @submit="onSubmit">
      <b-form-group label="标题">
        <b-form-input v-model="article.articleTitle"></b-form-input>
      </b-form-group>
      <b-form-group label="正文">
        <b-form-textarea v-model="article.articleContent" rows="16"></b-form-textarea>
      </b-form-group>
      <upload-img v-on:getOssUrl="getOssUrl"></upload-img>
      <b-img :src="article.ossUrl" class="mt-3" block style="max-width: 40%;"></b-img>
      <b-button type="submit" variant="primary" :disabled="noCompleted" class="mt-3">提交</b-button>
    </b-form>
  </b-container>
</template>

<script>
import UploadImg from './tools/UploadImg';

export default {
  name: 'CreateArticle',
  components: {UploadImg},
  data () {
    return {
      createArticle: this.getDomain() + 'article/create',
      article: {
        articleTitle: undefined,
        articleContent: undefined,
        ossUrl: undefined
      },
      isCreating: false
    }
  },
  computed: {
    noCompleted() {
      return !this.article.ossUrl || !this.article.articleContent || !this.article.articleTitle || this.isCreating
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.__axios(this.createArticle, this.article, this.handleForm)
    },
    handleForm() {
      this.$message.success('上传成功');
      this.article = {
        articleTitle: undefined,
        articleContent: undefined,
        ossUrl: undefined
      }
    },
    getOssUrl(url) {
      if (url) {
        this.article.ossUrl = url
      }
    }
  }
}
</script>
